import { GatewayAvancementApi } from "@src/data/avancement/avancement.api";
import { avancementKeys } from "@src/data/avancement/hook/avancement.keys";
import { useQuery } from "@tanstack/react-query";

export function useAvancementSocieteQuery(
  siren: string | undefined,
  millesime: number | undefined
) {
  return useQuery({
    queryKey: avancementKeys.detail(siren ?? "", millesime ?? 0),
    queryFn: () => GatewayAvancementApi.getAvancementForAdmin(siren!, millesime!),
    staleTime: Infinity,
    enabled: !!siren && !!millesime,
    select: (data) => (siren ? data[siren] : undefined),
  });
}
